// @ vendors
const trim = require('lodash/string/trim');
// @ utilities
import { v4 as uuidv4 } from 'uuid';
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');
const { emailSentModalCloseLink, otpAuthenticationLink, requestGenericErrorLink } = require('utilities/taggingInfo/profileEditorViewTagging'); 

// @actions
const { outdateGlobalPosition } = require('./myGlobalPosition');
const { success } = require("actions/notifications");

// @ constants
const actionTypes = require('constants/actionTypes');
const {
    FILTERS_INVALID,
    FILTERS_VALID,
    REQUESTED_LIST_ACCOUNTS,
    REQUESTED_LIST_CARDS,
    REQUESTED_LIST_WALLETS,
    REQUESTED_LIST_FUNDS,
    REQUESTED_LIST_PLANS,
    REQUESTED_LIST_SAVINGS,
    EXPIRED_REQUEST_CODE,
    } = require('constants/index');

/*

 Leave these lines commented as we still need to test in production, once tested can be deleted,
 this is for this issue : https://jira.globant.com/browse/OPE099-181

/*

 Leave these lines commented as we still need to test in production, once tested can be deleted,
 this is for this issue : https://jira.globant.com/browse/OPE099-181

const setFilterCustomAccountsInProgress = (accountId) => ({
    type: actionTypes.SET_PROFILE_EDIT_SETTINGS_ACCOUNT_REQUEST,
    payload: {
        accountId
    }
});

const setFilterCustomCardsInProgress = (cardId) => ({
    type: actionTypes.SET_PROFILE_EDIT_SETTINGS_CARD_REQUEST,
    payload: {
        cardId
    }
});

const setFilterCustomWalletsInProgress = (walletId) => ({
    type: actionTypes.SET_PROFILE_EDIT_SETTINGS_WALLET_REQUEST,
    payload: {
        walletId
    }
});*/

const setFilterCustomWalletsSuccess = (walletId, valid) => ({
    type: actionTypes.SET_PROFILE_EDIT_SETTINGS_WALLET_SUCCESS,
    payload: {
        walletId,
        valid
    }
});

const setFilterCustomWalletsFailure = walletId => ({
    type: actionTypes.SET_PROFILE_EDIT_SETTINGS_WALLET_FAILURE,
    payload: {
        walletId
    }
});

const setFilterCustomFuturesSuccess = (futureId, valid) => ({
    type: actionTypes.SET_PROFILE_EDIT_SETTINGS_FUTURE_SUCCESS,
    payload: {
        futureId,
        valid
    }
});

const setFilterCustomFuturesFailure = futureId => ({
    type: actionTypes.SET_PROFILE_EDIT_SETTINGS_FUTURE_FAILURE,
    payload: {
        futureId
    }
});

/*
 Leave these lines commented as we still need to test in production, once tested can be deleted,
 this is for this issue : https://jira.globant.com/browse/OPE099-181

const setFilterCustomFundsInProgress = (fundId) => ({
    type: actionTypes.SET_PROFILE_EDIT_SETTINGS_FUND_REQUEST,
    payload: {
        fundId
    }
});*/

const setFilterCustomFundsSuccess = (fundId, valid) => ({
    type: actionTypes.SET_PROFILE_EDIT_SETTINGS_FUND_SUCCESS,
    payload: {
        fundId,
        valid
    }
});

const setFilterCustomFundsFailure = fundId => ({
    type: actionTypes.SET_PROFILE_EDIT_SETTINGS_FUND_FAILURE,
    payload: {
        fundId
    }
});

/*
 Leave these lines commented as we still need to test in production, once tested can be deleted,
 this is for this issue : https://jira.globant.com/browse/OPE099-181

const setFilterCustomSavingsInProgress = (savingId) => ({
    type: actionTypes.SET_PROFILE_EDIT_SETTINGS_SAVING_REQUEST,
    payload: {
        savingId
    }
});*/

const setFilterCustomSavingsSuccess = (savingId, valid) => ({
    type: actionTypes.SET_PROFILE_EDIT_SETTINGS_SAVING_SUCCESS,
    payload: {
        savingId,
        valid
    }
});

const setFilterCustomSavingsFailure = savingId => ({
    type: actionTypes.SET_PROFILE_EDIT_SETTINGS_SAVING_FAILURE,
    payload: {
        savingId
    }
});

/*
 Leave these lines commented as we still need to test in production, once tested can be deleted,
 this is for this issue : https://jira.globant.com/browse/OPE099-181

const setFilterCustomPlansInProgress = (planId) => ({
    type: actionTypes.SET_PROFILE_EDIT_SETTINGS_PLAN_REQUEST,
    payload: {
        planId
    }
});*/

const setFilterCustomPlansSuccess = (planId, valid) => ({
    type: actionTypes.SET_PROFILE_EDIT_SETTINGS_PLAN_SUCCESS,
    payload: {
        planId,
        valid
    }
});

const setFilterCustomPlansFailure = planId => ({
    type: actionTypes.SET_PROFILE_EDIT_SETTINGS_PLAN_FAILURE,
    payload: {
        planId
    }
});

const setFilterCustomLoansSuccess = (loanId, valid) => ({
    type: actionTypes.SET_PROFILE_EDIT_SETTINGS_LOAN_SUCCESS,
    payload: {
        loanId,
        valid
    }
});

const setFilterCustomAccountsSuccess = (accountId, valid) => ({
    type: actionTypes.SET_PROFILE_EDIT_SETTINGS_ACCOUNT_SUCCESS,
    payload: {
        accountId,
        valid
    }
});

const setFilterCustomAccountsFailure = accountId => ({
    type: actionTypes.SET_PROFILE_EDIT_SETTINGS_ACCOUNT_FAILURE,
    payload: {
        accountId
    }
});

const setFilterCustomCardsSuccess = (cardId, valid) => ({
    type: actionTypes.SET_PROFILE_EDIT_SETTINGS_CARD_SUCCESS,
    payload: {
        cardId,
        valid
    }
});

const setFilterCustomCardsFailure = cardId => ({
    type: actionTypes.SET_PROFILE_EDIT_SETTINGS_CARD_FAILURE,
    payload: {
        cardId
    }
});

const setFilterCustomWallets = (dispatch, wallet, walletId, valid) => {
    const alias = trim(wallet.get('name'));
    const validFilter = (valid) ? FILTERS_INVALID : FILTERS_VALID;
    const customValidFilter = (valid) ? FILTERS_VALID : FILTERS_INVALID;
    const requestData = {
        query: {
            listaValores: {
                valores: [
                    {
                        contrato: {
                            numerodecontrato: wallet.get('accountNumber'),
                            producto: wallet.get('product')
                        },
                        descripcion: alias,
                        descripcionPersonalizada: alias,
                        filtroValido: validFilter,
                        filtroValidoPersonalizado: customValidFilter
                    }
                ]
            },
            listaSolicitada: REQUESTED_LIST_WALLETS
        }
    };

    dispatch(setFilterCustomWalletsSuccess(walletId, valid));
    return APIPost(dispatch, apiURLBuilder.getURL('setCustomProfileEditSettings'), requestData)
        .catch(() => dispatch(setFilterCustomWalletsFailure(walletId)));
}

const setFilterCustomFutures = (dispatch, future, futureId, valid) => {
    const alias = trim(future.get('descripcion'));
    const validFilter = future.getIn(['filtros', 'valido']) === FILTERS_VALID ? FILTERS_VALID : FILTERS_INVALID;
    const customValidFilter = (valid) ? FILTERS_VALID : FILTERS_INVALID;

    const requestData = {
        query: {
            listaCuentas: {
                cuentas: [
                    {
                        cnuevo: {
                            numerodecontrato: future.getIn(['cnuevo', 'numerodecontrato']),
                            producto: future.getIn(['cnuevo', 'producto'])
                        },
                        cviejo: {
                            numerodecontrato: future.getIn(['cviejo', 'numerodecontrato']),
                            subgrupo: future.getIn(['cviejo', 'subgrupo'])
                        },
                        descripcion: alias,
                        descripcionPersonalizada: alias,
                        filtroValido: validFilter,
                        filtroValidoPersonalizado: customValidFilter
                    }
                ]
            },
            listaSolicitada: REQUESTED_LIST_ACCOUNTS
        }
    };

    dispatch(setFilterCustomFuturesSuccess(futureId, valid))
    return APIPost(dispatch, apiURLBuilder.getURL('setCustomProfileEditSettings'), requestData)
        .catch(() => dispatch(setFilterCustomFuturesFailure(futureId)));
};

const setFilterCustomFunds = (dispatch, fund, fundId, valid) => {
    const alias = trim(fund.get('descripcion'));
    const validFilter = (valid) ? FILTERS_INVALID : FILTERS_VALID;
    const customValidFilter = (valid) ? FILTERS_VALID : FILTERS_INVALID;
    const requestData = {
        query: {
            listaFondos: {
                fondos: [
                    {
                        contrato: {
                            numerodecontrato: fund.get('contrato').get('numerodecontrato'),
                            producto: fund.get('contrato').get('producto')
                        },
                        descripcion: alias,
                        descripcionPersonalizada: alias,
                        filtroValido: validFilter,
                        filtroValidoPersonalizado: customValidFilter
                    }
                ]
            },
            listaSolicitada: REQUESTED_LIST_FUNDS
        }
    };

    dispatch(setFilterCustomFundsSuccess(fund.getIn(['contrato', 'numerodecontrato']), valid));
    return APIPost(dispatch, apiURLBuilder.getURL('setCustomProfileEditSettings'), requestData)
        .catch(() => dispatch(setFilterCustomFundsFailure(fund.get('contrato').get('numerodecontrato'))));
}

const setFilterCustomPlans = (dispatch, plan, planId, valid) => {
    const alias = trim(plan.get('descripcion'));
    const validFilter = (valid) ? FILTERS_INVALID : FILTERS_VALID;
    const customValidFilter = (valid) ? FILTERS_VALID : FILTERS_INVALID;
    const requestData = {
        query: {
            listaFondos: {
                fondos: [
                    {
                        contrato: {
                            numerodecontrato: plan.get('contrato').get('numerodecontrato'),
                            producto: plan.get('contrato').get('producto')
                        },
                        descripcion: alias,
                        descripcionPersonalizada: alias,
                        filtroValido: validFilter,
                        filtroValidoPersonalizado: customValidFilter
                    }
                ]
            },
            listaSolicitada: REQUESTED_LIST_PLANS
        }
    };

    dispatch(setFilterCustomPlansSuccess(plan.get('contrato').get('numerodecontrato'), valid));
    return APIPost(dispatch, apiURLBuilder.getURL('setCustomProfileEditSettings'), requestData)
        .catch(() => dispatch(setFilterCustomPlansFailure(plan.get('contrato').get('numerodecontrato'))));
}

const setFilterCustomLoans = (dispatch, loan, loanId, valid) => {
    const alias = loan.get('alias');
    const validFilter = valid ? FILTERS_INVALID : FILTERS_VALID;
    const customValidFilter = valid ? FILTERS_VALID : FILTERS_INVALID;
    const requestData = {
        query: {
            listaPrestamos: {
                prestamos: [
                    {
                        cnuevo: {
                            numerodecontrato: loan.get('newContractNumber'),
                            producto: loan.get('newProduct')
                        },
                        descripcion: alias,
                        descripcionPersonalizada: alias,
                        filtroValido: validFilter,
                        filtroValidoPersonalizado: customValidFilter
                    }
                ]
            },
            listaSolicitada: REQUESTED_LIST_PLANS
        }
    };

    dispatch(setFilterCustomLoansSuccess(loanId, valid));
    return APIPost(dispatch, apiURLBuilder.getURL('setCustomProfileEditSettings'), requestData);
}

const setFilterCustomAccounts = (dispatch, account, accountId, valid) => {
    const alias = account.get('isAliasUpdating')
        ? account.get('aliasTentative')
        : account.get('alias');
    const validFilter = account.getIn(['filters', 'valid']) ? FILTERS_VALID : FILTERS_INVALID;
    const customValidFilter = valid ? FILTERS_VALID : FILTERS_INVALID;
    const requestData = {
        query: {
            listaCuentas: {
                cuentas: [
                    {
                        cnuevo: {
                            numerodecontrato: account.get('newContractNumber'),
                            producto: account.get('newProduct')
                        },
                        cviejo: {
                            numerodecontrato: account.get('contractNumber'),
                            subgrupo: account.get('product')
                        },
                        descripcion: alias,
                        descripcionPersonalizada: alias,
                        filtroValido: validFilter,
                        filtroValidoPersonalizado: customValidFilter
                    }
                ]
            },
            listaSolicitada: REQUESTED_LIST_ACCOUNTS
        }
    };

    dispatch(setFilterCustomAccountsSuccess(accountId, valid))
    return APIPost(dispatch, apiURLBuilder.getURL('setCustomProfileEditSettings'), requestData)
        .catch(() => dispatch(setFilterCustomAccountsFailure(accountId)));
};

const setFilterCustomCards = (dispatch, card, cardId, valid) => {
    const alias = card.getIn(['alias', 'isUpdating'])
        ? card.getIn(['alias', 'tentative'])
        : card.getIn(['alias', 'current']);
    const validFilter = card.getIn(['filters', 'valid']) ? FILTERS_VALID : FILTERS_INVALID;
    const customValidFilter = valid ? FILTERS_VALID : FILTERS_INVALID;
    const requestData = {
        query: {
            listaSolicitada: REQUESTED_LIST_CARDS,
            listaTarjetas: {
                tarjetas: [
                    {
                        descripcion: alias,
                        descripcionPersonalizada: alias,
                        filtroValido: validFilter,
                        filtroValidoPersonalizado: customValidFilter,
                        pan: card.get('number')
                    }
                ]
            }
        }
    };

    dispatch(setFilterCustomCardsSuccess(cardId, valid))
    return APIPost(dispatch, apiURLBuilder.getURL('setCustomProfileEditSettings'), requestData)
        .catch(() => dispatch(setFilterCustomCardsFailure(cardId)));
};

const setFilterCustomSavings = (dispatch, saving, savingId, valid) => {
    const alias = saving.get('description');
    const validFilter = valid ? FILTERS_INVALID : FILTERS_VALID;
    const customValidFilter = valid ? FILTERS_VALID : FILTERS_INVALID;
    const requestData = {
        query: {
            listaDepositos: {
                depositos: [
                    {
                        cnuevo: {
                            numerodecontrato: saving.get('contractNumber'),
                            producto: saving.get('product')
                        },
                        descripcion: alias,
                        descripcionPersonalizada: alias,
                        filtroValido: validFilter,
                        filtroValidoPersonalizado: customValidFilter
                    }
                ]
            },
            listaSolicitada: REQUESTED_LIST_SAVINGS
        }
    };

    dispatch(setFilterCustomSavingsSuccess(savingId, valid));
    return APIPost(dispatch, apiURLBuilder.getURL('setCustomProfileEditSettings'), requestData)
        .catch(() => dispatch(setFilterCustomSavingsFailure(saving.get('contractNumber'))));
}

const postFilterCustomAccounts = (accountId, valid) => (dispatch, getState)  => {
    const immAccounts = getState().accounts;
    const account = immAccounts.get('byId').get(accountId);
    const hasAccount = account.size > 0;
    const isAlreadyFetching = !!account.get('filters').get('isFetching');
    const hasError = !!account.get('filters').get('error');

    if (hasAccount && !isAlreadyFetching && !hasError) {
        setFilterCustomAccounts(dispatch, account, accountId, valid);
    }
};

const postAccountPreference = collection => dispatch => {
    const USER_PREFERENCE_REQUEST_HEADER_VERSION = 2;

    const params = {
        header: {
            version: USER_PREFERENCE_REQUEST_HEADER_VERSION
        },
        query: {
            preferences: [
                {
                    name: "PAYMENTS_AND_CARDS_ACCOUNTS_ORDER",
                    accounts: collection
                }
            ]
        }
    };

    return APIPost(dispatch, apiURLBuilder.getURL('setAccountPreference'), params)
        .then(() => {
            dispatch(outdateGlobalPosition());
        });
};

const postFilterCustomWallets = (walletId, valid) => (dispatch, getState) => {
    const immWallets = getState().brokerWallets.get('walletList');
    const wallet = immWallets.get(walletId);
    const hasWallet = wallet.size > 0;

    if (hasWallet) {
        setFilterCustomWallets(dispatch, wallet, walletId, valid);
    }
};

const postFilterCustomFutures = (futureId, valid) => (dispatch, getState)  => {
    const immFutures = getState().brokerWallets.get('futuresList');
    const future = immFutures.get(futureId);
    const hasFuture = future.size > 0;

    if (hasFuture) {
        setFilterCustomFutures(dispatch, future, futureId, valid);
    }
};

const postFilterCustomFunds = (fundId, valid) => (dispatch, getState)  => {
    const immFunds = getState().brokerWallets.get('fundsList');
    const fund = immFunds.get(fundId);
    const hasFund = fund.size > 0;

    if (hasFund) {
        setFilterCustomFunds(dispatch, fund, fundId, valid);
    }
};

const postFilterCustomPlans = (planId, valid) => (dispatch, getState) => {
    const immPlans = getState().brokerWallets.get('plansList');
    const plan = immPlans.get(planId);
    const hasWallet = plan.size > 0;

    if (hasWallet) {
        setFilterCustomPlans(dispatch, plan, planId, valid);
    }
};

const postFilterCustomLoans = (loanId, valid) => (dispatch, getState) => {
    const loan = getState().loans.get('byId').get(loanId);
    setFilterCustomLoans(dispatch, loan, loanId, valid);
};

const postFilterCustomCards = (cardId, valid) => (dispatch, getState) => {
    const cards = getState().cards;
    const card = cards.get('byId').get(cardId);
    const hasCard = card.size > 0;
    const isAlreadyFetching = !!card.get('filters').get('isFetching');
    const hasError = !!card.get('filters').get('error');

    if (hasCard && !isAlreadyFetching && !hasError) {
        setFilterCustomCards(dispatch, card, cardId, valid);
    }
};

const postFilterCustomSavings = (savingId, valid) => (dispatch, getState) => {
    const immSavings = getState().globalPosition.getIn(['savings', 'allSavings']);
    const saving = immSavings.filter(immSaving => immSaving.get('id') === savingId).first();

    if (!!saving) {
        setFilterCustomSavings(dispatch, saving, savingId, valid);
    }
};
const setEmailUuid = () => {
    return ({
        type: actionTypes.SET_PROFILE_EDIT_UUID,
        payload: {
            uuid: uuidv4()
        }
    });
}

const closeProfileOtpEmailModal = () => (dispatch, getState) => {
    emailSentModalCloseLink();
    dispatch({type: actionTypes.SET_PROFILE_EDIT_SEND_OTP_EMAIL_CLOSE_MODAL});
    dispatch({
        type: actionTypes.PROFILE_EDIT_VALIDATE_STEP,
        payload: {
            step: 1
        }
    });
};

const initOtpEmailAPI = (dispatch, getState, actionTypeSuccess, actionTypeFailure, hasError, notificationMsg = '') => {
    const immProfileEditor = getState().profileEditor;
    const immStep = immProfileEditor.getIn(['steps', 0]);
    const uuid = immStep.get('uuid') || '';

    const requestData = {
        query: {
            'email': immStep.get('repeatEmail'),
            'sessionId': uuid,
        }
    };

    return APIPost(dispatch, `${apiURLBuilder.getURL('userEmail')}/otp/init`, requestData)
    .then(res => {
        dispatch({type: actionTypeSuccess, payload: { hasError }});
        if(notificationMsg) {
            dispatch(success({ message: notificationMsg })); 
        }
    })
    .catch(resp => {
        requestGenericErrorLink(resp?.errors?.status);
        dispatch({
            type: actionTypeFailure, 
            payload: {errorStatus: resp?.error?.status}
        });
    });
}

const initProfileOtpEmail = () => (dispatch, getState) => {
    const hasError = false;
    dispatch({type: actionTypes.SET_PROFILE_EDIT_SEND_OTP_EMAIL_REQUEST});
    initOtpEmailAPI(dispatch, getState, actionTypes.SET_PROFILE_EDIT_SEND_OTP_EMAIL_SUCCESS, actionTypes.SET_PROFILE_EDIT_SEND_OTP_EMAIL_FAILURE, hasError);
}

const resendOtpEmail = (notificationMsg) => (dispatch, getState) => {
    const hasError = false;
    dispatch({type: actionTypes.SET_PROFILE_EDIT_RESEND_OTP_EMAIL_REQUEST, payload: { hasError }});
    initOtpEmailAPI( dispatch, getState, actionTypes.SET_PROFILE_EDIT_RESEND_OTP_EMAIL_SUCCESS, actionTypes.SET_PROFILE_EDIT_RESEND_OTP_EMAIL_FAILURE, hasError, notificationMsg );
}

const profileVerifyOtpEmail = ({ otp }) => (dispatch, getState) => {
    dispatch({type: actionTypes.SET_PROFILE_EDIT_VERIFY_OTP_EMAIL_REQUEST});

    const immProfileEditor = getState().profileEditor;
    const immStep = immProfileEditor.getIn(['steps', 0]);
    const uuid = immStep.get('uuid') || '';

    const requestData = {
        query: {
            'email': immStep.get('repeatEmail'),
            'sessionId': uuid,
            'otp': otp,
        }
    };

    APIPost(dispatch, `${apiURLBuilder.getURL('userEmail')}/otp/validate`, requestData)
    .then(res => {
        otpAuthenticationLink();
        dispatch({type: actionTypes.SET_PROFILE_EDIT_VERIFY_OTP_EMAIL_SUCCESS});
    })
    .catch(resp => {
        if(resp.error.status === EXPIRED_REQUEST_CODE) {
            const hasError = true;
            dispatch({type: actionTypes.SET_PROFILE_EDIT_RESEND_OTP_EMAIL_REQUEST, payload: { hasError }});
            initOtpEmailAPI( dispatch, getState, actionTypes.SET_PROFILE_EDIT_RESEND_OTP_EMAIL_SUCCESS, actionTypes.SET_PROFILE_EDIT_RESEND_OTP_EMAIL_FAILURE, hasError );
        } else {
            dispatch({
                type: actionTypes.SET_PROFILE_EDIT_VERIFY_OTP_EMAIL_FAILURE, 
                payload: {
                    errorStatus: resp.error.status,
                }});
        }
    });
}

module.exports = {
    postFilterCustomAccounts,
    postAccountPreference,
    postFilterCustomCards,
    postFilterCustomWallets,
    postFilterCustomFutures,
    postFilterCustomFunds,
    postFilterCustomPlans,
    postFilterCustomLoans,
    postFilterCustomSavings,
    initProfileOtpEmail,
    closeProfileOtpEmailModal,
    profileVerifyOtpEmail,
    setEmailUuid,
    resendOtpEmail,
};